// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyB-x2DGjh_ZW_g5wdNZwwSMLP6EdFkYbTo",
  authDomain: "pm-construction-app.firebaseapp.com",
  projectId: "pm-construction-app",
  storageBucket: "pm-construction-app.firebasestorage.app",
  messagingSenderId: "21923554491",
  appId: "1:21923554491:web:d8b27d26dac41787af759e",
  measurementId: "G-YHL601VJWC",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export async function getFirebaseMessaging() {
  const supported = await isSupported();
  if (supported) {
    return getMessaging(app);
  } else {
    return null;
  }
}

export { getToken, onMessage };
